import { Box, Typography } from '@mui/material';
import { ReactComponent as CheckboxIcon } from 'assets/Checkbox.svg';
import { replayChrome } from 'sentryReplayPrivacy';

interface ValidationItem {
  text: string;
  isValid: boolean;
}

interface PasswordValidationListProps {
  items: ValidationItem[];
}

function PasswordValidationList({ items }: PasswordValidationListProps): JSX.Element {
  return (
    <Box sx={{ mt: 4 }}>
      {items.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 1,
          }}
        >
          {item.isValid ? (
            <CheckboxIcon
              style={{
                width: 20,
                height: 20,
                marginRight: 8,
              }}
            />
          ) : (
            <Typography
              sx={{
                color: 'text.primary',
                fontSize: 14,
                fontWeight: 400,
                mr: 1,
              }}
            >
              •
            </Typography>
          )}
          <Typography
            {...replayChrome}
            sx={{
              color: 'text.primary',
              fontSize: 14,
              fontWeight: 400,
              lineHeight: '20px',
            }}
          >
            {item.text}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default PasswordValidationList;
